
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import ServiceCategoryTabs from './ServiceCategoryTabs';
import { Treatment } from '@/data/treatmentData';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ServicesManagementCardProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  dentalTreatments: Treatment[];
  cosmeticTreatments: Treatment[];
  handleToggleTreatment: (id: string, category: 'dental' | 'cosmetic') => void;
  handlePriceChange: (id: string, value: string, category: 'dental' | 'cosmetic') => void;
  handleSaveChanges: () => void;
}

const ServicesManagementCard: React.FC<ServicesManagementCardProps> = ({
  activeTab,
  setActiveTab,
  dentalTreatments,
  cosmeticTreatments,
  handleToggleTreatment,
  handlePriceChange,
  handleSaveChanges
}) => {
  const navigate = useNavigate();
  
  return (
    <Card className="mb-6">
      <CardHeader className="flex flex-row items-center">
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={() => navigate(-1)}
          className="mr-3 -ml-2"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <CardTitle>Manage Your Services</CardTitle>
          <CardDescription>
            Select the services you offer and set your custom pricing.
            These will be visible to patients who browse your profile.
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        <ServiceCategoryTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          dentalTreatments={dentalTreatments}
          cosmeticTreatments={cosmeticTreatments}
          handleToggleTreatment={handleToggleTreatment}
          handlePriceChange={handlePriceChange}
        />
      </CardContent>
      <CardFooter className="flex justify-end">
        <Button variant="outline" className="mr-2" onClick={() => navigate(-1)}>Cancel</Button>
        <Button onClick={handleSaveChanges}>Save Changes</Button>
      </CardFooter>
    </Card>
  );
};

export default ServicesManagementCard;
